var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5026 5.4375C8.46094 5.4375 3.30135 9.19542 1.21094 14.5C3.30135 19.8046 8.46094 23.5625 14.5026 23.5625C20.5443 23.5625 25.7039 19.8046 27.7943 14.5C25.7039 9.19542 20.5443 5.4375 14.5026 5.4375ZM14.5026 20.5417C11.1676 20.5417 8.46094 17.835 8.46094 14.5C8.46094 11.165 11.1676 8.45833 14.5026 8.45833C17.8376 8.45833 20.5443 11.165 20.5443 14.5C20.5443 17.835 17.8376 20.5417 14.5026 20.5417ZM14.5026 10.875C12.4968 10.875 10.8776 12.4942 10.8776 14.5C10.8776 16.5058 12.4968 18.125 14.5026 18.125C16.5084 18.125 18.1276 16.5058 18.1276 14.5C18.1276 12.4942 16.5084 10.875 14.5026 10.875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDetails);
export default __webpack_public_path__ + "static/media/eye-details.8a864e886708a42946e08fbb1fc0a17d.svg";
export { ForwardRef as ReactComponent };